import React, { useState } from "react";
import { Link } from "react-router-dom";
import useQuery from "../../../Hooks/useQuery";
import SEO from "../../SEO";
import { BLOG_DATA } from "../Blog/Blogs/index";
import { SERVICES } from "../../Pages/Services/Main/Services/Services";
import "./Search.scss";

export default function SearchPage() {
  const query = useQuery();
  const [filter, setFilter] = useState("all");
  const LIST = {
    all: [...SERVICES, ...BLOG_DATA],
    blogs: BLOG_DATA,
    services: SERVICES,
  };
  const [results, setResults] = useState(() => LIST[filter]);

  const handleChange = (event) => {
    setFilter(event.target.value);
  };

  const applyFilter = () => {
    setResults(LIST[filter]);
  };

  const list = results.filter((s) =>
    s.title.toLowerCase().includes(query.get("s")?.toLowerCase())
  );

  return (
    <>
      <SEO
        title="Search | Pacific Outdoor Living"
        description=""
        profileURL={"https://pacificoutdoorliving.com/search"}
        type="website"
        ogTitle="Search results"
      />

      <div className="search-page">
        <div className="box">
          <div className="filter">
            <select value={filter} onChange={handleChange}>
              <option value="all">All</option>
              <option value="services">Services</option>
              <option value="blogs">Blog Posts</option>
            </select>
            <button onClick={applyFilter}>Apply Filter</button>
          </div>
        </div>
        <div className="search-result">
          {list.length ? (
            list.map((service) => (
              <ResultCard key={service.destination} service={service} />
            ))
          ) : (
            <div className="no-result">No results for your query</div>
          )}
        </div>
      </div>
    </>
  );
}

function ResultCard({ service }) {
  return (
    <div className="result-card">
      <Link to={service.destination}>
        <img src={service.image} alt={service.title} />
        <h4>{service.title}</h4>
        <div>
          {service.categories.map((category, i) => (
            <p key={`${category}-${i}`}>{category}</p>
          ))}
        </div>
      </Link>
    </div>
  );
}
